import { ClipboardList, MessagesSquare, CalendarCheck, TrendingUp, MonitorSmartphone, School } from "lucide-react";

const STEPS = [
  {
    icon: MessagesSquare,
    title: "Tell us about your child",
    text: "Send a free consultation request or WhatsApp us. Share the subject, grade and where they're struggling.",
  },
  {
    icon: ClipboardList,
    title: "We assess & place",
    text: "We identify the gaps and match your child with the right tutor and a small group — or one-on-one if preferred.",
  },
  {
    icon: CalendarCheck,
    title: "Book your lessons",
    text: "Choose online lessons from home, or in-person sessions at our Duvhapark, Witbank academy. We confirm every slot personally.",
  },
  {
    icon: TrendingUp,
    title: "Watch the marks grow",
    text: "Practical teaching, regular feedback to parents, and past-paper practice as exams approach.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="bg-primary" data-testid="how-it-works-section">
      <div className="grain-overlay mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="eyebrow-label !text-amber-400" data-testid="how-eyebrow">How it works</p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl" data-testid="how-heading">
              A clear way forward.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-white/75">
              From first message to better marks — simple for parents, encouraging for students.
            </p>

            <div className="mt-10 grid grid-cols-1 gap-4">
              <div className="rounded-2xl border border-white/15 bg-white/10 p-6 backdrop-blur" data-testid="mode-online-card">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-500 text-slate-900">
                    <MonitorSmartphone className="h-5 w-5" />
                  </span>
                  <h3 className="font-heading text-lg font-bold text-white">Online lessons</h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-white/75">
                  Live video lessons from anywhere in South Africa. Same tutors, same personal attention — no travel needed.
                </p>
              </div>
              <div className="rounded-2xl border border-white/15 bg-white/10 p-6 backdrop-blur" data-testid="mode-inperson-card">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-500 text-slate-900">
                    <School className="h-5 w-5" />
                  </span>
                  <h3 className="font-heading text-lg font-bold text-white">In-person lessons</h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-white/75">
                  Face-to-face at 43 Benjamin Bennet Street, Duvhapark, Witbank — a real classroom, part of a real academy.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="grid gap-5 sm:grid-cols-2" data-testid="how-steps">
              {STEPS.map(({ icon: Icon, title, text }, i) => (
                <li
                  key={title}
                  className="relative rounded-2xl border border-white/15 bg-white/[0.07] p-7 backdrop-blur transition-transform duration-300 hover:-translate-y-1"
                  data-testid={`how-step-${i + 1}`}
                >
                  <span className="absolute right-6 top-5 font-heading text-4xl font-extrabold text-white/10">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/15 text-amber-400">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-bold text-white">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/70">{text}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
